import muiRootWrapper from './mui-root-wrapper';

export const wrapRootElement = muiRootWrapper;
